import React from 'react'
import { css } from '@emotion/core'
import { Separator, colors } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

const rowCss = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 0;
`

const textGroupCss = css`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const titleCss = css`
  font-weight: bold;
  font-size: 1rem;
`

const statusCss = css`
  font-size: 0.875rem;
  color: ${colors.gray60};
`

const editButtonCss = css`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${colors.blue50};
  font-size: 0.875rem;
  flex-shrink: 0;
  margin-left: 16px;
`

export default function NotificationCategoryRow({ title, channels = [], onEdit }) {
  const { t } = useTranslation()

  const activeChannels = channels.filter((c) => c.subscribed).map((c) => c.name)
  const statusText = activeChannels.length
    ? `${t('notifications.status.on', 'ON')}: ${activeChannels.join(', ')}`
    : t('notifications.status.off', 'OFF')

  return (
    <>
      <div css={rowCss}>
        <div css={textGroupCss}>
          <span css={titleCss}>{title}</span>
          <span css={statusCss}>{statusText}</span>
        </div>
        <button
          css={editButtonCss}
          type="button"
          onClick={onEdit}
          aria-label={`${t('notifications.edit.label', 'Edit')} ${title}`}
        >
          {t('notifications.edit.label', 'Edit')}
        </button>
      </div>
      <Separator />
    </>
  )
}
